
import { useState, useEffect } from "react";
import { ContactInfo } from "@/components/ContactInfo";
import { ActionButtons } from "@/components/ActionButtons";
import { ServicesSection } from "@/components/ServicesSection";
import { ContactDialog } from "@/components/ContactDialog";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { format } from "date-fns";
import { 
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

const Index = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [visitCount, setVisitCount] = useState(0);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    const currentCount = parseInt(localStorage.getItem('visitCount') || '0');
    setVisitCount(currentCount + 1);
    localStorage.setItem('visitCount', (currentCount + 1).toString());

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-blue-600 relative overflow-x-hidden">
      <Header />
      
      <div className="pt-20 sm:pt-24">
        <Hero />

        <ServicesSection />
        <ContactDialog isOpen={isContactOpen} onOpenChange={setIsContactOpen} />

        {/* Temporarily commented out - Mapa do Site section
        <div className="bg-white/90 p-2 sm:p-4 mt-4 sm:mt-8">
          <div className="container mx-auto flex flex-col gap-4">
            <div className="w-full">
              <NavigationMenu>
                <NavigationMenuList>
                  <NavigationMenuItem>
                    <NavigationMenuTrigger className="text-sm">
                      Mapa do Site
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      <div className="grid gap-3 p-4 w-[280px] sm:w-[400px]">
                        <NavigationMenuLink 
                          className="cursor-pointer hover:bg-blue-100 p-2 rounded text-sm"
                          onClick={() => navigate('/')}
                        >
                          Início
                        </NavigationMenuLink>
                        <NavigationMenuLink 
                          className="cursor-pointer hover:bg-blue-100 p-2 rounded text-sm"
                          onClick={() => navigate('/saiba-mais')}
                        >
                          Saiba Mais
                        </NavigationMenuLink>
                        <NavigationMenuLink 
                          className="cursor-pointer hover:bg-blue-100 p-2 rounded text-sm"
                          onClick={() => navigate('/software-recursos')}
                        >
                          Softwares e Recursos
                        </NavigationMenuLink>
                        <NavigationMenuLink 
                          className="cursor-pointer hover:bg-blue-100 p-2 rounded text-sm"
                          onClick={() => navigate('/programas-ambientais')}
                        >
                          Programas Ambientais
                        </NavigationMenuLink>
                        <NavigationMenuLink 
                          className="cursor-pointer hover:bg-blue-100 p-2 rounded text-sm"
                          onClick={() => navigate('/servicos-online')}
                        >
                          Serviços Online
                        </NavigationMenuLink>
                        <NavigationMenuLink 
                          className="cursor-pointer hover:bg-blue-100 p-2 rounded text-sm"
                          onClick={() => navigate('/equipe')}
                        >
                          Nossa Equipe
                        </NavigationMenuLink>
                      </div>
                    </NavigationMenuContent>
                  </NavigationMenuItem>
                </NavigationMenuList>
              </NavigationMenu>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
              <div className="text-base sm:text-xl font-mono text-blue-800 text-center">
                {format(currentTime, isMobile ? 'dd/MM/yy HH:mm' : 'dd/MM/yyyy HH:mm:ss')}
              </div>
              <div className="text-xs sm:text-sm text-blue-600">
                Visitas: {visitCount}
              </div>
            </div>
          </div>
        </div>
        */}

      </div>
    </div>
  );
};

export default Index;
